<template>

    <AjanlatBase :titleExtra="titleExtra"  v-if="szabAtvetelLatszik() || sorszamLatszik() || egyuttkotesLatszik()">

        <v-form slot="biztositoi-adatok" ref="ajanlat-adatok">

            <v-layout row wrap>

                <BnFormField v-if="szabAtvetelLatszik()" :attributes="aegon_szabatvetel_mod" />

                <BnFormField v-if="sorszamLatszik()" :attributes="aegon_nyomdszab_sorszam" />

                <BnFormField v-if="egyuttkotesLatszik()" :attributes="aegon_egyuttkot_azon" />

            </v-layout>

        </v-form>

    </AjanlatBase>

</template>

<script>
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import AjanlatBase from '../KGFBAjanlatBase.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';

export default {
    components: { BnFormField, AjanlatBase },
    mixins: [offerData],
    methods: {
        szabAtvetelLatszik() {
            return !this.$store.getters.isOvb;
        },
        egyuttkotesLatszik() {
            return parseInt(this.$store.getters.tarifaData.szerz_casco, 10) === 1
                || this.kedvezmenyek.egyuttlakas === true
                || this.kedvezmenyek.egyuttbaleset === true
                || (this.kedvezmenyek.egyuttcasco === true && !this.egyuttkotve)
                || this.kedvezmenyek.egyuttelet === true
                || this.kedvezmenyek.lakaspartner === true
                || this.kedvezmenyek.vallvagyon === true;
        },
        sorszamLatszik() {
            return this.szabatvetel === 'C';
        },
        szabatvetelChange() {
            this.szabatvetel = this.$store.getters.tarifaData.aegon_szabatvetel_mod;
        },
    },
    mounted() {
        this.szabatvetel = this.$store.getters.tarifaData.aegon_szabatvetel_mod;
    },
    data() {
        return {
            name: 'AjanlatAdatokB3_V0',
            version: 'v0',
            szabatvetel: '',
            aegon_szabatvetel_mod: {
                type: 'select',
                label: 'Szabályzat átvételi mód',
                visible: true,
                editable: true,
                help: true,
                mezo: 'aegon_szabatvetel_mod',
                path: 'tarifaData.aegon_szabatvetel_mod',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    { key: 'M', value: 'Email küldés (letöltés internetről)' },
                    { key: 'N', value: 'Nyomtatás szabályzattal együtt' },
                    { key: 'C', value: 'Nyomtatás és Nyomdai szabályzat' },
                ],
                change: this.szabatvetelChange,
            },
            aegon_nyomdszab_sorszam: {
                type: 'text',
                label: 'Nyomdai szabályzat sorszáma',
                visible: true,
                editable: true,
                mezo: 'aegon_nyomdszab_sorszam',
                help: true,
                path: 'tarifaData.aegon_nyomdszab_sorszam',
            },
            aegon_szemle: {
                type: 'select',
                label: 'Szemle módja',
                visible: true,
                editable: true,
                help: true,
                mezo: 'aegon_szemle',
                path: 'tarifaData.aegon_szemle',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    { key: 'A', value: 'Alkuszi szemle' },
                    { key: 'B', value: 'Biztosítói szemle' },
                ],
            },
            aegon_extrak_felsorolas: {
                type: 'text',
                label: 'Szérián kívüli extrák felsorolása',
                visible: true,
                editable: true,
                help: true,
                mezo: 'aegon_extrak_felsorolas',
                path: 'tarifaData.aegon_extrak_felsorolas',
            },
            aegon_egyuttkot_azon: {
                type: 'text',
                label: 'Alfa partner kedvezmény',
                visible: true,
                editable: true,
                help: true,
                mezo: 'aegon_egyuttkot_azon',
                path: 'tarifaData.aegon_egyuttkot_azon',
                mask: '!V',
            },
        };
    },
};
</script>
